import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPage } from "../features/filter/filterSlice";

const Pagination = () => {
  const dispatch = useDispatch();
  const { page } = useSelector((state) => state.filter || {});
  const { totalTransactions } = useSelector((state) => state.transaction || {});
  const handlePageSelect = (pageNum) => dispatch(setPage(pageNum));
  const pages = new Array(Math.ceil(totalTransactions / 10)).fill();

  return (
    <div className="pagination">
      {pages.map((_, i) => (
        <button
          key={i}
          onClick={() => handlePageSelect(i + 1)}
          className={`pageNumber ${page === i + 1 ? "pageActive" : ""}`}
        >
          {i + 1}
        </button>
      ))}
    </div>
  );
};

export default Pagination;
